(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const wire = () => {
    document.querySelectorAll('[data-singular-video]').forEach(wrapper => {
      if (wrapper.dataset.singularWired) return;
      wrapper.dataset.singularWired = 'true';
      const video = wrapper.querySelector('video');
      const button = wrapper.querySelector('[data-singular-play]');
      if (!video || !button) return;
      let userPaused = reduced.matches;
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.loop = true;
      const label = () => {
        const text = video.paused ? button.dataset.playLabel : button.dataset.pauseLabel;
        button.setAttribute('aria-label', text);
        button.querySelector('[data-singular-play-label]').textContent = text;
      };
      const play = () => video.play().catch(label);
      button.addEventListener('click', () => {
        userPaused = !video.paused;
        if (video.paused) play(); else video.pause();
      });
      video.addEventListener('play', label);
      video.addEventListener('pause', label);
      const observer = new IntersectionObserver(entries => {
        if (entries[0].isIntersecting && !userPaused) play(); else video.pause();
      }, {threshold: .15});
      observer.observe(video);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) video.pause(); else if (!userPaused && video.getBoundingClientRect().bottom > 0 && video.getBoundingClientRect().top < innerHeight) play();
      });
      if (reduced.matches) video.pause();
      label();
    });
    const dialog = document.getElementById('size-chart-modal');
    if (dialog?.classList.contains('singular-size-dialog')) {
      document.querySelectorAll('[data-singular-size-open]').forEach(button => {
        button.onclick = () => {
          dialog.style.display = '';
          if (!dialog.open) dialog.showModal();
        };
      });
      dialog.querySelector('[data-singular-size-close]').onclick = () => { dialog.style.display = ''; dialog.close(); };
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wire); else wire();
  document.addEventListener('shopify:section:load', wire);
})();
